import { hostMatches } from "../network/SourceRegistry.ts";
import { ExtractionError, type SourceProfile } from "./types.ts";

export function resolveUrl(
  raw: string,
  base: string,
  profile: Pick<SourceProfile, "allowedHosts">,
): string {
  let url: URL;
  try {
    url = new URL(raw.trim(), base);
  } catch {
    throw new ExtractionError("INVALID_URL", "URL inválida.");
  }
  if (
    !["https:", "http:"].includes(url.protocol) ||
    url.username ||
    url.password ||
    url.port ||
    !hostMatches(url.hostname, profile.allowedHosts)
  )
    throw new ExtractionError("INVALID_URL", `URL no autorizada: ${url.origin}${url.pathname}`);
  return url.href;
}
